import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsIceSkateNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M30.522 29.869a3.364 3.364 0 00-.467-3.614l-1.286-1.545a2.9 2.9 0 002.06-2.76v-2.89a3.313 3.313 0 00-2.19-3.11l-3.73-1.34-8.23-4.42-1.35-7.96A2.477 2.477 0 0012.89.17h-1.22a2.484 2.484 0 00-2.35 1.7l-1.43 4.3H4.98l.66-3.19H3.95l-2.1 10.2a34.974 34.974 0 00-.68 6.85 4.826 4.826 0 002.083 3.95L1.648 26.7a3.4 3.4 0 002.924 5.123h22.875a3.363 3.363 0 003.075-1.954zM10.88 2.389a.829.829 0 01.79-.56h1.22a.816.816 0 01.81.68l.62 3.666H9.629L10.88 2.39zM2.83 20.03c0-1.326.08-2.652.24-3.97l10.14 5.45h3.48L3.32 14.33c.04-.27.09-.55.15-.82l1.17-5.681h9.969l.45 2.672-1.7 3.17 1.45.78 1.41-2.64 1.65.89-1.42 2.63 1.46.78 1.41-2.63 1.65.89L19.56 17l1.45.78 1.42-2.63 1.65.88-1.42 2.63 1.46.79 1.51-2.83 2.45.88a1.675 1.675 0 011.09 1.56v2.89a1.225 1.225 0 01-1.22 1.22H5.97a3.145 3.145 0 01-3.14-3.14zm18.345 4.8v.688a1.66 1.66 0 01-1.66 1.658h-7.031a1.66 1.66 0 01-1.66-1.658v-.687h10.35zm-18.12 4.465a1.725 1.725 0 01.014-1.753l1.7-2.87c.392.108.798.162 1.205.159h3.2v.687a3.312 3.312 0 003.31 3.308h7.032a3.312 3.312 0 003.309-3.308v-.687h3.894l2.069 2.482a1.747 1.747 0 01-1.341 2.863H4.572a1.726 1.726 0 01-1.516-.881z"
        fill=""
      />
    </svg>
  )
);
SvgSportsIceSkateNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsIceSkateNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsIceSkateNormalMedium;
